export const shippingMethod: any = {
  ups: 'UPS',
  fedex: 'Fedex',
  freight: 'Freight',
  col: 'Collect',
}
